export default __webpack_public_path__ + "static/media/heroes.b413d9df.png";